import React from 'react';
import {
  ViewButton,
  EditButton,
} from '../../Common/DataTable/tableActionButtons';
import { getFilter, getSort } from '../../Common/DataTable/tableHelpers';
import { cdnUrl } from '../../../helpers/file';
import moment from 'moment';

const createTableColumns = (openViewModal, openEditModal) => [
  {
    title: 'Image',
    name: 'image',
    width: 140,
    formatterComponent: ({ row, value }) => (
      <a href={cdnUrl(value)} target="_blank" rel="noreferrer">
        <img
          src={cdnUrl(value)}
          alt={row.name}
          style={{ maxWidth: '120px', maxHeight: '60px' }}
        />
      </a>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
  {
    title: 'Name',
    name: 'name',
  },
  {
    title: 'Title',
    name: 'title',
    width: 150,
  },
  {
    title: 'Message',
    name: 'message',
  },
  {
    title: 'Time Tags',
    name: 'timeTags',
    width: 250,
    wordWrapEnabled: true,
    formatterComponent: ({ value }) =>
      Array.isArray(value) && value.length
        ? `${value.join(', ').substring(0, 150)}...`
        : '',
  },
  {
    title: 'Day of Week',
    name: 'dayOfWeek',
    width: 80,
  },
  {
    title: 'Language',
    name: 'lang',
    width: 80,
    hidden: true,
  },
  {
    title: 'Active',
    name: 'active',
    width: 80,
    formatterComponent: ({ value }) => (
      <span
        className={`badge badge-${value ? 'success' : 'danger'} font-size-12`}>
        {value ? 'Yes' : 'No'}
      </span>
    ),
  },
  {
    title: 'Created',
    name: 'createdAt',
    width: 150,
    formatterComponent: ({ value }) => moment(value).format('DD/MM/YYYY HH:mm'),
    filter: (value, filter) =>
      getFilter(moment(value).format('DD/MM/YYYY'), filter.value),
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
  },
  {
    title: 'Action',
    name: 'action',
    width: 100,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        <ViewButton row={row} onPress={openViewModal} />
        <EditButton row={row} onPress={openEditModal} />
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
